export default function PlusIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <g clipPath='url(#clip0_622_720)'>
        <path
          d='M15.8337 10.8333H10.8337V15.8333H9.16699V10.8333H4.16699V9.16663H9.16699V4.16663H10.8337V9.16663H15.8337V10.8333Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_622_720'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
